var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBmslive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.96,
    height: 67.695,
    viewBox: "0 0 104.96 67.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 104.96,
    height: 67.695,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BMS_LIVE",
    "data-name": "BMS LIVE",
    transform: "translate(104.96 67.695) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PROMOTED_BY",
    "data-name": "PROMOTED BY",
    transform: "translate(52.333 9.151)",
    fill: "#0c0d0d",
    fontSize: 12,
    fontFamily: "Texturina-Medium, Texturina",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53,
    y: 0,
    letterSpacing: "0.149em"
  }, "PROM"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.15em"
  }, "OTED "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.14em"
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M9.743,50.453a.545.545,0,0,1-.582-.582V21.915a.526.526,0,0,1,.582-.583h7.821a.526.526,0,0,1,.582.583v20.8c0,1,.209,1.415.832,1.415s.832-.416.832-1.415V40.885a.57.57,0,0,1,.583-.583h7.238a.6.6,0,0,1,.583.583v8.986a.627.627,0,0,1-.583.582Z",
    transform: "translate(7.333 17.076)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5040",
    "data-name": "Path 5040",
    d: "M24.609,29.571a9.424,9.424,0,0,1-3.754-.72.116.116,0,0,0-.162.108L21.147,44.2a.633.633,0,0,0,.623.582h6.113a.594.594,0,0,0,.582-.582l.465-15.637a.148.148,0,0,0-.225-.13,7.924,7.924,0,0,1-4.094,1.136",
    transform: "translate(16.565 22.745)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5041",
    "data-name": "Path 5041",
    d: "M43.625,17.667,42.44,15.595l-2.108,1.042-1.185-2.072-2.108,1.042-1.187-2.072-2.107,1.042L32.559,12.5l-2.107,1.042-1.187-2.072-2.107,1.042L22.669,27.51,28.1,29.223a2.9,2.9,0,0,1,2.755-2.1A2.93,2.93,0,0,1,33.746,30.1v.059a2.323,2.323,0,0,1-.1.8l5.531,1.748Z",
    transform: "translate(18.147 9.186)",
    fill: "#e7364d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5042",
    "data-name": "Path 5042",
    d: "M25.469,23.5a.585.585,0,0,1-.479-.6V15.537a.6.6,0,0,1,.6-.61h5.148a2.251,2.251,0,0,1,.4.036,2.369,2.369,0,0,1,1.916,2.346V22.9a.612.612,0,0,1-.6.623l-.108-.011a.586.586,0,0,1-.479-.6v-5.58A1.147,1.147,0,0,0,30.93,16.2l-.193-.023H29.612v6.741a.615.615,0,0,1-.6.623l-.108-.013a.583.583,0,0,1-.479-.6V16.173H26.175v6.741a.574.574,0,0,1-.178.432.618.618,0,0,1-.42.178Z",
    transform: "translate(20.005 11.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5043",
    "data-name": "Path 5043",
    d: "M30.224,26.743a.585.585,0,0,1-.479-.6.594.594,0,0,1,.587-.61,1.122,1.122,0,0,0,1.077-.826l.612-2.107-2-6.91a.637.637,0,0,1,.394-.778l.265-.013a.616.616,0,0,1,.466.42l1.485,5.149,1.509-5.149a.586.586,0,0,1,.682-.42l.036.013a.616.616,0,0,1,.394.778l-2.06,7.09-.646,2.274a2.412,2.412,0,0,1-.837,1.233,2.27,2.27,0,0,1-1.39.479Z",
    transform: "translate(23.811 11.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5044",
    "data-name": "Path 5044",
    d: "M9.662,25.1a.619.619,0,0,1-.5-.623V13.479a.618.618,0,0,1,.18-.454.593.593,0,0,1,.443-.18l.108.013a.63.63,0,0,1,.515.621V16.6h1.172a2.538,2.538,0,0,1,.42.036,2.451,2.451,0,0,1,1.988,2.443v3.545a2.446,2.446,0,0,1-2.407,2.479H9.794Zm.731-1.269h1.174a1.191,1.191,0,0,0,1.174-1.21V19.073a1.19,1.19,0,0,0-.97-1.187l-.2-.023H10.393Z",
    transform: "translate(7.333 10.282)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5045",
    "data-name": "Path 5045",
    d: "M14.687,23.509a2.443,2.443,0,0,1-1.975-2.443V17.378a2.529,2.529,0,0,1,.706-1.763,2.364,2.364,0,0,1,1.7-.727,2.335,2.335,0,0,1,.418.034,2.454,2.454,0,0,1,1.988,2.443v3.689a2.547,2.547,0,0,1-.706,1.761,2.348,2.348,0,0,1-1.689.718,1.893,1.893,0,0,1-.443-.025m.623-7.33-.2-.022a1.175,1.175,0,0,0-1.174,1.208v3.689a1.189,1.189,0,0,0,.958,1.185l.2.025a1.194,1.194,0,0,0,1.174-1.21V17.365a1.176,1.176,0,0,0-.958-1.187",
    transform: "translate(10.176 11.918)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5046",
    "data-name": "Path 5046",
    d: "M18.239,23.5a2.453,2.453,0,0,1-1.975-2.443V17.374a2.448,2.448,0,0,1,2.407-2.481,2.517,2.517,0,0,1,.418.036,2.452,2.452,0,0,1,1.977,2.432v3.689a2.549,2.549,0,0,1-.708,1.761,2.351,2.351,0,0,1-1.7.718,1.693,1.693,0,0,1-.42-.025m.623-7.33-.2-.022a1.175,1.175,0,0,0-1.174,1.208v3.689a1.189,1.189,0,0,0,.958,1.185l.2.025a1.16,1.16,0,0,0,.826-.347,1.2,1.2,0,0,0,.347-.862V17.361a1.176,1.176,0,0,0-.958-1.187",
    transform: "translate(13.019 11.922)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5047",
    "data-name": "Path 5047",
    d: "M20.311,25.168a.611.611,0,0,1-.5-.623V13.481a.625.625,0,0,1,.178-.456.614.614,0,0,1,.445-.18l.106.013a.629.629,0,0,1,.515.623v6.55l2.839-3.282a.6.6,0,0,1,.574-.191l.311.144a.651.651,0,0,1,.047.9l-2.166,2.454,2.227,4.192a.64.64,0,0,1,.059.466.683.683,0,0,1-.3.384.6.6,0,0,1-.407.072.63.63,0,0,1-.432-.3l-2-3.785-.765.862v2.6a.65.65,0,0,1-.18.456.613.613,0,0,1-.43.18Z",
    transform: "translate(15.857 10.282)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5048",
    "data-name": "Path 5048",
    d: "M35.954,23.532a2.28,2.28,0,0,1-1.6-1.161.69.69,0,0,1-.059-.492.623.623,0,0,1,.286-.384.6.6,0,0,1,.407-.072.639.639,0,0,1,.432.311,1.052,1.052,0,0,0,.729.528,1.021,1.021,0,0,0,.911-.275,1.1,1.1,0,0,0,.335-.875,1.066,1.066,0,0,0-.443-.825l-1.664-1.223a2.332,2.332,0,0,1-.229-3.569,2.166,2.166,0,0,1,1.833-.6,2.267,2.267,0,0,1,1.592,1.125.726.726,0,0,1,.061.479.609.609,0,0,1-.695.456.659.659,0,0,1-.432-.3,1.018,1.018,0,0,0-.706-.49.979.979,0,0,0-.839.25,1.026,1.026,0,0,0-.31.826.99.99,0,0,0,.43.767l1.664,1.2a2.357,2.357,0,0,1,.96,1.8,2.352,2.352,0,0,1-2.636,2.5",
    transform: "translate(27.434 11.908)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5049",
    "data-name": "Path 5049",
    d: "M38.09,25.175a.642.642,0,0,1-.517-.623V13.488a.648.648,0,0,1,.193-.456.6.6,0,0,1,.43-.18l.108.013a.618.618,0,0,1,.5.623v3.126H39.98a2.38,2.38,0,0,1,2.395,2.477v5.461a.619.619,0,0,1-.609.636l-.11-.013a.62.62,0,0,1-.513-.623V19.091a1.189,1.189,0,0,0-.96-1.185l-.216-.023H38.794v6.669a.621.621,0,0,1-.621.636Z",
    transform: "translate(30.077 10.288)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5050",
    "data-name": "Path 5050",
    d: "M43.093,23.5a2.442,2.442,0,0,1-1.975-2.443V17.371a2.446,2.446,0,0,1,2.407-2.477,2.358,2.358,0,0,1,.42.036,2.452,2.452,0,0,1,1.988,2.441v3.689a2.543,2.543,0,0,1-.708,1.761,2.337,2.337,0,0,1-1.687.718,2.73,2.73,0,0,1-.445-.036m.636-7.317-.2-.023a1.128,1.128,0,0,0-.826.347,1.219,1.219,0,0,0-.335.85v3.687a1.189,1.189,0,0,0,.958,1.187l.2.023a1.148,1.148,0,0,0,.826-.347,1.193,1.193,0,0,0,.347-.862V17.361a1.209,1.209,0,0,0-.97-1.174",
    transform: "translate(32.915 11.923)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5051",
    "data-name": "Path 5051",
    d: "M52.758,15.667A.688.688,0,0,0,52.7,15.2a.613.613,0,0,0-.4-.288l-.108-.013a.623.623,0,0,0-.6.479c0,.025-.672,2.791-1.187,4.9l-.011.047-.013-.047c-.5-2.1-1.185-4.863-1.2-4.9a.56.56,0,0,0-.479-.466L48.6,14.9a.622.622,0,0,0-.587.479c-.011.025-.67,2.791-1.185,4.9l-.013.047-.013-.047c-.5-2.108-1.185-4.863-1.185-4.9a.616.616,0,0,0-.479-.466l-.239.013a.621.621,0,0,0-.443.754l1.784,7.377a.634.634,0,0,0,.479.466l.1.013a.591.591,0,0,0,.587-.479c.013-.025.682-2.791,1.2-4.9l.013-.047.011.047c.528,2.121,1.187,4.9,1.187,4.9a.654.654,0,0,0,.479.466l.1.013a.591.591,0,0,0,.587-.479",
    transform: "translate(35.575 11.927)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5052",
    "data-name": "Path 5052",
    d: "M26.152,21.3a6.016,6.016,0,0,0-5.8,2.947h2.218a.547.547,0,1,1,0,1.095H19.851a5.947,5.947,0,0,0-.319,1.628h3.561a.547.547,0,0,1,0,1.095H19.575a5.963,5.963,0,0,0,.454,1.628h3.612a.547.547,0,1,1,0,1.095H20.652a6.015,6.015,0,1,0,5.5-9.487",
    transform: "translate(15.635 17.03)",
    fill: "#4b4350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M57.06,42.664H55.629a.513.513,0,0,0-.052-.005H50.209l-.483,0a2.3,2.3,0,0,1-2.215-2.2,2.185,2.185,0,1,1,4.352.27h4.323a.581.581,0,0,0,.49-.279.54.54,0,0,0,.106-.31V34.008h-.014v-.855a.594.594,0,0,0-.582-.583h-6.4c-.025,0-.054,0-.086,0a2.192,2.192,0,1,1,2.171-1.941H56.81a.584.584,0,0,0,.583-.582V21.915a.6.6,0,0,0-.583-.583H39.088a.583.583,0,0,0-.582.583V49.87a.6.6,0,0,0,.582.583H57.06a.584.584,0,0,0,.582-.583V43.246a.594.594,0,0,0-.582-.582",
    transform: "translate(30.824 17.076)",
    fill: "#4b4350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M46.753,21.671h-8.07l-1,3.4-.268,11.824c0,.708-.353,1.041-.81,1.041s-.808-.333-.808-1.041l-.18-10.544-6.557-2.072L29.459,23a.966.966,0,0,0,.034-.338v-.121a1.6,1.6,0,0,0-1.554-1.635,1.569,1.569,0,0,0-1.475,1.142l-.151.508a7.952,7.952,0,0,1,.335,9.611c.607,5.861,1.286,12.524,1.451,14.586a4.6,4.6,0,0,0,1.12,2.933,5.267,5.267,0,0,0,3.956,1.269h6.8c3.286,0,4.534-1.248,4.743-4.2l2.575-24.5a.514.514,0,0,0-.54-.582",
    transform: "translate(21.064 16.738)",
    fill: "#4b4350"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmslive);
export default __webpack_public_path__ + "static/media/BMS LIVE.02b0d957e42f321edf45856f4be1f400.svg";
export { ForwardRef as ReactComponent };